import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected, } from '@reduxjs/toolkit';
import { serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { ITireDiscardDashboard, ITireDiscardItem, defaultDashboardValue, } from 'app/shared/model/tire-discard-dashboard.model';

export interface TireDiscardDashboardState {
  loading: boolean;
  errorMessage: string | null;

  dashboard: ITireDiscardDashboard;
  discardItems: ITireDiscardItem[];
}

const initialState: TireDiscardDashboardState = {
  loading: false,
  errorMessage: null,

  dashboard: defaultDashboardValue,
  discardItems: [],
};

const dashboardApiUrl = '/api/tire-discard-data';
const itemsApiUrl = '/api/tire-discard-all';

export const getTireDiscardDashboard = createAsyncThunk(
  'tireDiscardDashboard/fetch_dashboard',
  async (filters?: any) => {
    return axios.get<ITireDiscardDashboard>(dashboardApiUrl, {
      params: filters,
    });
  },
  {
    serializeError: serializeAxiosError,
  }
);

export const getTireDiscardItems = createAsyncThunk(
  'tireDiscardDashboard/fetch_items',
  async (filters?: any) => {
    return axios.get<ITireDiscardItem[]>(itemsApiUrl, {
      params: filters,
    });
  },
  {
    serializeError: serializeAxiosError,
  }
);

export const TireDiscardDashboardSlice = createSlice({
  name: 'tireDiscardDashboard',

  initialState,

  reducers: {
    reset() {
      return initialState;
    },
  },

  extraReducers(builder) {
    builder

      .addMatcher(
        isPending(
          getTireDiscardDashboard,
          getTireDiscardItems
        ),
        state => {
          state.loading = true;
          state.errorMessage = null;
        }
      )

      .addMatcher(
        isFulfilled(getTireDiscardDashboard),
        (state, action) => {
          state.loading = false;
          state.dashboard = action.payload.data;
        }
      )

      .addMatcher(
        isFulfilled(getTireDiscardItems),
        (state, action) => {
          state.loading = false;
          state.discardItems = action.payload.data;
        }
      )

      .addMatcher(
        isRejected(
          getTireDiscardDashboard,
          getTireDiscardItems
        ),
        (state, action) => {
          state.loading = false;
          state.errorMessage =
            action.error.message ?? 'Erro ao carregar dados';
        }
      );
  },
});

export const { reset } = TireDiscardDashboardSlice.actions;

export default TireDiscardDashboardSlice.reducer;